export default "__VITE_ASSET__CZ4EOwSo__"